import Cookie from 'js-cookie';
import { LocationUtilities, SiteUtilities } from '../utils';
import Submit from '../form-submit-handlers';
import GA4Utilities from '../utils/ga4-utilities';
import fwcrmFormHandlers from './fwcrm-form-handlers';

const fchatSignupForm = (className, form) => {
  const $form = $(form);
  const signUpApiUrl = $(form).data('signup-url') || 'https://web.freshchat.com/app/v1/signup/unity_signup?noredirect=true';
  const email = $form.find('input[name^="email"]').val();
  const emailHash = SiteUtilities.getShaHash(email);
  const errorWrapper = $form.find('.error-wrapper');
  const firstName = $form.find('.first-name-form').val() || '';
  const lastName = $form.find('.last-name-form').val() || '';
  const phoneNumber = $form.find('.phone-form').val() || '';
  const companyName = $form.find('.company-form').val() || '';
  const isExternalIframeSignup = $form.parents('.external-iframe-signup').length;
  const currentReferrer = SiteUtilities.getCurrentReferrer();
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
  const geoLocation = LocationUtilities.getGeoLocation();
  const country = geoLocation ? geoLocation.countryName : '';
  let fsCookie = '';
  const currencyUnit = (geoLocation && geoLocation.countryName && geoLocation.countryCode) ? getFchatCurrencyUnit(geoLocation.countryName, geoLocation.countryCode) : 'usd';
  try {
    fsCookie = freshsales.anonymous_id;
  } catch (exception) {
    SiteUtilities.log(
      'Freshchat fsales anonymous id  exception.',
      'submitHandlers.fchatForm',
      2,
      exception
    );
  }

  const fmAssetId = $form.find('.fm-asset-id').val() || $form.data('fm_asset_id') || 3649313;
  const tacticId = SiteUtilities.getTacticID() || '';
  const compositeKey = SiteUtilities.getCompositeKey(email, fmAssetId, tacticId);

  const sessionObj = window.session ? JSON.parse(JSON.stringify(window.session)) : {};
  if (!SiteUtilities.GDPRFunctionalCookieDisabled()) {
    // Binding maxmind_session
    sessionObj.location = geoLocation;
  }
  if (sessionObj) {
    sessionObj.composite_stitching_key = compositeKey;
    sessionObj.allocadia_asset_id = fmAssetId;
    sessionObj.allocadia_tactic_id = tacticId;

    sessionObj.ga_client_id = `${SiteUtilities.getGAClientID()}:${compositeKey}`;
  }

  //  $(form).find('#landing_url').val(window.location.href);
  // $(form).find('#session_json').val(JSON.stringify(session));
  const fsalesId = typeof freshsales !== 'undefined' ? freshsales.anonymous_id : 'Error - freshsales is not defined';
  const data = {
    user_first_name: firstName,
    user_last_name: lastName,
    user_phone: phoneNumber,
    user_company: companyName,
    user_name: firstName + ' ' + lastName,
    email: email,
    gdpr_first_opt_in: ($form.find('input[name="send_promotions"]').is(':checked')),
    country,
    session_json: JSON.stringify(sessionObj),
    first_referrer: (isExternalIframeSignup && currentReferrer) ? currentReferrer : (Cookie.get('fw_fr') || window.location.href),
    first_landing_url: Cookie.get('fw_flu') || '',
    freshsales_id: fsalesId,
    fs_cookie: fsCookie,
    currency: currencyUnit
  };
  if (!SiteUtilities.GDPRFunctionalCookieDisabled()) {
    data['region_name'] = geoLocation ? geoLocation.regionName : '';
    data['zip_code'] = geoLocation ? geoLocation.zipCode : '';
  }
  const plan = $form.find('input[name="plan-id"]').val();
  if (plan !== undefined && plan !== '') {
    data['plan'] = plan;
  }

  $.ajax({
    url: signUpApiUrl,
    type: 'POST',
    data: $.param(data),
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
    dataType: 'json',
    xhrFields: {
      withCredentials: true
    },
    success: (response) => {
      if (response.success === true) {
        response.composite_stitching_key = compositeKey;
        fchatSignupFormSuccess($form, response);
      } else if (response.success === false) {
        errorWrapper.addClass('error');
        $form.find('.button').removeClass('button--loading').removeAttr('disabled');
        window.location.href = response.redirectUri + `?ehash=${emailHash}`;
      }
    },
    error: (xhr, status, err) => {
      $form.find('.button').removeClass('button--loading').removeAttr('disabled');
      errorWrapper.addClass('error');
      errorWrapper.html('Service unavailable');
      SiteUtilities.log(
        'Internal Server error',
        'submitHandlers.fchatSignupForm',
        2,
        err
      );
    },
    complete: () => {
      $form.find('.button').removeClass('button--loading').attr('disabled', null);
    }
  });
};

const fchatWhatsappHandler = (className, form) => {
  const $form = $(form);
  const email = $form.find('input[name^="email"]').val();
  const emailHash = SiteUtilities.getShaHash(email);
  const signupHandler = $(form).data('signup-handler');
  const firstName = $form.find('.first-name-form').val() || '';
  const lastName = $form.find('.last-name-form').val() || '';
  const phoneNumber = $form.find('.phone-form').val() || '';
  const companyName = $form.find('.company-form').val() || '';
  const teamMembers = $form.find('.employees-field').val() || '';
  const website = $form.find('.website-form').val() || '';
  const signupEnabled = $form.find('.signup-checkbox input[type="checkbox"]')[0].checked || false;
  const geoLocation = LocationUtilities.getGeoLocation();
  const redirect = (signupEnabled === true) ? $form.attr('data-redirect') : $form.attr('data-url-without-redirect');
  // Freshmarketer Data
  const freshmarketerData = {
    freshmarketerObject: {
      first_name: firstName,
      last_name: lastName,
      email: email,
      company: companyName,
      phone: phoneNumber,
      country: geoLocation ? geoLocation.countryName : '',
      contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
      custom_field: {
        cf_website: website,
        cf_fchatnumberofemployees: teamMembers,
        cf_freshmarketer_list: $form.find('.fm-list-id').val()
      }
    }
  };

  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
  if (!signupEnabled) {
    setTimeout(function () {
      jQuery.when(
        SiteUtilities.freshmarketerPost(freshmarketerData, false, form)
      ).then(function () {
        window.location.href = redirect + `/?ehash=${emailHash}`;
      });
    }, 300);
  } else {
    if (signupHandler) {
      Submit[signupHandler](className, form);
    }
  }
};

const fchatSignupFormSuccess = ($form, response, alohaV2 = false) => {
  const redirect = SiteUtilities.trimAndremoveTrailingSlash($form.attr('data-redirect'));
  const isExternalIframeSignup = $form.parents('.external-iframe-signup').length;
  const email = $form.find('input[name^="email"]').val();
  const emailHash = SiteUtilities.getShaHash(email);
  const firstName = $form.find('.first-name-form').val() || '';
  const lastName = $form.find('.last-name-form').val() || '';
  const phoneNumber = $form.find('.phone-form').val() || '';
  const companyName = $form.find('.company-form').val() || '';
  const teamMembers = $form.find('.employees-field').val() || '';
  const website = $form.find('.website-form').val() || '';
  const errorWrapper = $form.find('.error-wrapper');
  const currentReferrer = SiteUtilities.getCurrentReferrer();
  const geoLocation = LocationUtilities.getGeoLocation();
  let accountId;
  let redirectUrl;

  if (alohaV2) {
    const { product_signup_response: { redirect_url: redirectUrlResp, account: { id } = {} } = {} } = response;
    redirectUrl = (redirectUrlResp || '').replace(/\/$/, '');
    accountId = id;
  } else {
    accountId = response.defaultApp;
  }

  const domainUrl = redirectUrl || null;

  // Freshmarketer Data. We are passing email, contactable. Other fields will be sent by the product endpoint.
  const freshmarketerData = {
    freshmarketerObject: {
      first_name: firstName,
      last_name: lastName,
      email: email,
      company: companyName,
      phone: phoneNumber,
      country: geoLocation ? geoLocation.countryName : '',
      contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
      custom_field: {
        cf_freshmarketer_list: $form.find('.fm-list-id').val()
      },
      domainUrl,
      accountId: accountId,
      product: 'Freshchat',
      composite_stitching_key: response.composite_stitching_key || null
    }
  };

  GA4Utilities.ga4ThankYouEvent(accountId, redirectUrl, $form);
  SiteUtilities.passSignupResponseToGA(accountId, redirectUrl || '', 'Freshchat');
  if ($form.hasClass('freshchat-whatsapp-signup')) {
    freshmarketerData.freshmarketerObject.custom_field.cf_website = website;
    freshmarketerData.freshmarketerObject.custom_field.cf_fchatnumberofemployees = teamMembers;
  }

  let thankYouRedirect = `${redirect}/?account_id=${accountId}&ehash=${emailHash}`;
  if (isExternalIframeSignup) {
    thankYouRedirect = thankYouRedirect + '&post_to_partner=true';
    if (currentReferrer) {
      thankYouRedirect += `&first_referrer=${encodeURIComponent(currentReferrer)}`;
    }
  }

  const growSumoPayload = SiteUtilities.buildGrowSumoPayload('pk_S2P0ZRTBsc7OjyRUsxfNeyCSy3Ye8HNE', '');
  const collectorPayload = SiteUtilities.freshmarketerPost(freshmarketerData, false, $form, false);
  const admitadPayload = SiteUtilities.buildAdmitadPayload(growSumoPayload.customer_key);
  localStorage.setItem('fmarketerStartTime', new Date().toISOString());
  jQuery.when(
    SiteUtilities.postToKinesis({ growSumoPost: growSumoPayload, fmCollectorPost: collectorPayload, admitadPost: admitadPayload })
  ).catch(function (e) {
    SiteUtilities.log(
      'Error in Freshmarketer or GrowSumo Post API Call',
      'error',
      'fchat-form-handlers.js',
      1,
      e
    );
  }).always(function () {
    localStorage.setItem('fmarketerEndTime', new Date().toISOString());
    localStorage.removeItem('gsdata');
    errorWrapper.removeClass('error');
    SiteUtilities.triggersignupPerformanceLogApi(true);
    SiteUtilities.signupToProductRedirect(redirectUrl, isExternalIframeSignup);
  });
  // Make historyPushState an asynchronous operation to ensure that the upcoming SignupLog function can still access /signup as the page URL.
  SiteUtilities.historyPushState(thankYouRedirect, true);
};

const getFchatCurrencyUnit = (countryName, countryCode) => {
  // Currency selection handler
  const countryEU = [
    'Austria',
    'Belgium',
    'Cyprus',
    'Estonia',
    'Finland',
    'France',
    'Germany',
    'Greece',
    'Ireland',
    'Italy',
    'Latvia',
    'Luxembourg',
    'Malta',
    'Netherlands',
    'Portugal',
    'Slovakia',
    'Slovenia',
    'Spain',
    'Andorra',
    'Kosovo',
    'Montenegro',
    'Monaco',
    'San Marino',
    'The Vatican City'
  ];
  const currencyMap = {
    IN: 'inr',
    US: 'usd',
    EU: 'eur',
    GB: 'gbp',
    AU: 'aud'
  };
  let countrySelected = null;
  if (countryEU.indexOf(countryName) >= 0) {
    countrySelected = 'EU';
  } else if (currencyMap.hasOwnProperty(countryCode)) {
    countrySelected = countryCode;
  } else {
    countrySelected = 'US';
  }
  return currencyMap[countrySelected];
};

const fchatDemoRequestForm = (classname, form) => {
  const $form = $(form);
  let chatUsage = '';
  const checkboxes = $form.find('input[type="checkbox"]');
  $(checkboxes).each((index, element) => {
    if (element.checked) {
      chatUsage += $(element).parents('label.checkbox-control').text().trim() + ',';
    }
  });
  chatUsage = chatUsage.replace(/,\s*$/, '');
  const firstName = $form.find('input[name^="first-name"]').val();
  const lastName = $form.find('input[name^="last-name"]').val();
  const emailid = $form.find('input[name^="email"]').val();
  const phone = $form.find('input[name^="phone"]').val() || '';
  const companyName = $form.find('input[name^="company"]').val();
  const teamMembers = $form.find('input[name^="agents"]').val();
  const currentChatProduct = $form.find('select[name^="query"]').val();
  const emailHash = SiteUtilities.getShaHash(emailid);
  const geoLocation = LocationUtilities.getGeoLocation();

  // Freshmarketer Data
  const freshmarketerData = {
    freshmarketerObject: {
      first_name: firstName,
      last_name: lastName,
      email: emailid,
      company: companyName,
      phone: phone,
      country: geoLocation ? geoLocation.countryName : '',
      contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
      custom_field: {
        cf_fchatagentcount: teamMembers,
        cf_fchatcurrentchatproduct: currentChatProduct,
        cf_fchatusage: chatUsage,
        cf_freshmarketer_list: $form.find('.fm-list-id').val()
      }
    }
  };

  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');

  setTimeout(function () {
    jQuery.when(
      SiteUtilities.freshmarketerPost(freshmarketerData, false, form)
    ).then(function () {
      window.location.href = $form.attr('data-redirect') + `/?ehash=${emailHash}`;
    });
  }, 300);
};

var fchatLoginForm = function (classname, form) {
  const $form = $(form);
  const domain = $form.find('input.domain-form').val();
  const subdomainProduct = $form.find('.subdomain-product').val();

  if (!domain || !subdomainProduct) return;

  if (['.myfreshworks.com', '.freshworks.com'].includes(subdomainProduct)) {
    fwcrmFormHandlers.fwcrmLoginForm(classname, form);
  } else {
    const loginUrl = $form.data('login-url') || 'https://web.freshchat.com/app/v2/domain/available/web';
    const btnElement = $form.find('.button');
    btnElement.addClass('button--loading').attr('disabled', 'disabled');

    const errorHandler = () => {
      $form.find('.domain-form').parents('.form-field').addClass('error');
      $form.find('.error-wrapper').empty().append("<em class='error'>This account does not exist</em>");
      btnElement.removeClass('button--loading').removeAttr('disabled');
    };

    $.ajax({
      url: loginUrl,
      type: 'POST',
      data: JSON.stringify({ fcDomain: domain }),
      accept: 'application/json',
      contentType: 'application/json',
      dataType: 'json',
      success: (response) => {
        const { available } = response || {};
        if (available === false) {
          btnElement.removeClass('button--loading').removeAttr('disabled');
          window.location.href = `https://${domain}${subdomainProduct}`;
          GA4Utilities.loginFormSubmit(domain);
          return;
        }
        return errorHandler();
      },
      error: (xhr, status, err) => errorHandler()
    });
  }
};

var fchatForgotDomainForm = function (classname, form) {
  const $form = $(form);
  const email = $form.find('.email-form').val();
  const forgotDomainUrl = $form.data('forgot-domain-url') || 'https://web.freshchat.com/app/organisation/list?email=';
  if (!email) return;
  const btnElement = $form.find('.button');
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');

  const errorHandler = () => {
    btnElement.removeClass('button--loading').removeAttr('disabled');
    $form.find('.email-form').parents('.form-field').addClass('error');
    $form.find('.error-wrapper').empty().append("<em class='error'>This email does not exist</em>");
  };

  $.ajax({
    url: forgotDomainUrl + encodeURIComponent(email) + '&product=freshchat',
    type: 'GET',
    success: (response) => {
      if (!response) return errorHandler();
      btnElement.removeClass('button--loading').removeAttr('disabled');
      jQuery('.form-wrapper', '.forgot-domain-form-wrapper').slideUp(300);
      setTimeout(function () {
        jQuery('.forgot-domain-success').slideDown(300);
      }, 300);
    },
    error: (xhr, status, err) => errorHandler()
  });
};

export default {
  fchatSignupForm,
  fchatDemoRequestForm,
  getFchatCurrencyUnit,
  fchatSignupFormSuccess,
  fchatWhatsappHandler,
  fchatLoginForm,
  fchatForgotDomainForm
};
